<template>
  <div class="headerBox fvlrw">
    <div>
      <van-icon name="manager-o" />
      <span class="name">{{ name }}</span>
      <span class="userPhone themeColor">
        <span>{{ mobile && mobile.slice(0, 3) }}</span>
        <span>{{ mobile && mobile.slice(3, 7) }}</span>
        <span>{{ mobile && mobile.slice(7, 11) }}</span>
      </span>
    </div>
    <div class="managerBtn themeColor" @click="toContactsList">
      管理
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted, computed, watch } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { getContactsList } from '@/api/directSales'

export default {
  props: {},
  components: {},
  emits: ['clickCard', 'clickImg', 'go'],
  setup(props, { emit }) {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    const state = reactive({
      mobile: '',
      name: ''
    })
    const toContactsList = () => {
      emit('go', { path: '/contactsList', query: { from: 'confirmOrder' } })
      // router.push()
    }
    const getCustomerInfoFn = async () => {
      let currentContacts = store.state.currentContacts || {}
      let registerUser = currentContacts?.registerUser || null
      let currentUser = currentContacts?.currentUser || null
      if (!registerUser || !registerUser.name) {
        try {
          let registerUserInfo = store.state.registerUserInfo
          let name = registerUserInfo?.username || ''
          let mobile = registerUserInfo?.phone || ''
          registerUser = { name, mobile, register: true }
        } catch (e) {
          // showToast(e.message, '获取个人信息数据失败')
        }
      }
      if (!currentUser || !currentUser.name) {
        try {
          let listData = await getContactsList()
          let defaultContact = listData.find(item => item.defaultStatusFlag)
          currentUser = defaultContact || registerUser
        } catch (e) {
          currentUser = registerUser
        }
      }
      store.commit('SETCURRENTCONTACTS', { registerUser, currentUser })
    }
    watch(
      () => store.state.currentContacts,
      v => {
        state.name = v?.currentUser?.name || ''
        state.mobile = v?.currentUser?.mobile || ''
      },
      { immediate: true, deep: true }
    )
    watch(
      () => store.state.registerUserInfo,
      registerUserInfo => {
        let name = registerUserInfo?.username || ''
        let mobile = registerUserInfo?.phone || ''
        let registerUser = { name, mobile, register: true }
        let { currentUser } = store.state.currentContacts
        store.commit('SETCURRENTCONTACTS', { registerUser, currentUser })
      },
      { immediate: true, deep: true }
    )
    onMounted(() => {
      getCustomerInfoFn()
    })
    return {
      ...toRefs(state),
      toContactsList
    }
  }
}
</script>
<style lang="scss" scoped>
.headerBox {
  padding: 0 20px;
  height: 54px;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #333;
  background-color: #fff;
  .name {
    margin: 0 10px;
    font-weight: 400;
  }
  .userPhone {
    font-size: 14px;
    span {
      margin-right: 4px;
    }
  }
  .managerBtn {
    padding: 0 10px;
  }
}
</style>
